export default __webpack_public_path__ + "2010 Tunable disorder in a crystal of cold polar molecules.pdf";